export const TOKEN = 'colormylife-token';
export const REFRESH_TOKEN = 'colormylife-refresh-token';
